import { ResetPasswordCompletePage } from "@/features/auth/pages/ResetPasswordComplete";

const ResetPasswordComplete = () => {
  return <ResetPasswordCompletePage />;
};

export default ResetPasswordComplete;
